module.exports = __webpack_public_path__ + "static/media/tv-stream.d12cba3c.png";